import '../../media/css/AppToolbar.css';
import React from 'react';
import { ButtonToolbar,ButtonGroup, Button } from 'reactstrap';

class AppToolbar extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { operation: ("" || "index"), toolbar: "", loggedIn: opts.loggedIn };
		this.uid = "AppToolbar-"+window.glob.generateUid();
	};
	componentDidMount() {
		window.glob.register('toolbar',(t,t2)=> { this.setState({toolbar: t, toolbar2:t2 }) }, this.uid );
		window.glob.register('loggedIn',(t)=> { this.setState({loggedIn: t }) }, this.uid );
	};
	componentWillUnmount() {
		window.glob.unregister(['toolbar','loggedIn'],this.uid );
	}
	render() {
		const lo = ()=>{
			if ( ! this.state.loggedIn ) return "";
			const la = ()=>{ window.glob.logout() };
			return (
				<ButtonGroup size={"sm"} className={"mobile-no btn-icon"}>
					<Button color={"danger"} onClick={la}>
						<i>⎋</i>
						<b>Logout</b>
					</Button>
				</ButtonGroup>
			);
		};
		return (
			<ButtonToolbar className={"AppToolbar"}>
				<ButtonGroup size={"sm"}>
					{ (this.state.loggedIn ? this.state.toolbar : "")|| <div>&nbsp;</div> }
				</ButtonGroup>
				<ButtonGroup size={"sm"}>
					{ this.state.loggedIn ? this.state.toolbar2 : "" }
				</ButtonGroup>
				<div>
					{ lo() }
					<div className={"status-indicator"} />
				</div>
			</ButtonToolbar>
		);
	}
}

export default AppToolbar;